import React, { useState } from 'react';
import { FaGithub, FaExternalLinkAlt } from 'react-icons/fa';
import './Projects.css';
import img1 from '../../assets/project 1.png';
import img2 from '../../assets/project 2.png';
import img3 from '../../assets/project 3.png';
import img4 from '../../assets/project 4.png';
import img5 from '../../assets/project 5.png';
import img6 from '../../assets/project 6.png';
import img7 from '../../assets/project 7.png';
import img8 from '../../assets/project 8.png';
import img9 from '../../assets/project 9.png';
import img10 from '../../assets/ui 1.png';
import img11 from '../../assets/ui 2.png';
import img12 from '../../assets/ui 3.png';

const Projects = () => {
    const [visible, setVisible] = useState(4);
    const [category, setCategory] = useState('ui'); // 🔹 Default: UI projects first

    const showButton = () => setVisible((prev) => prev + 4);
    const hideButton = () => setVisible((prev) => prev - 4);

    // 🔹 Development Projects (Original)
    const devProjects = [
        {
            id: 1,
            title: 'Phone Resale House',
            src: img1,
            href: 'https://phone-resale-house.web.app/',
            detail:
                'It`s a resale website for phones, where buyers can buy and sellers can sell their used phones.',
            github: 'https://github.com/sabidalam/Phone-Resale-House',
            feature_1: '• Separate Dashboard for admin, buyer and seller.',
            feature_2: '• Use Stripe for payment system.',
            feature_3: '• Seller can advertise their product for quick sell.',
            feature_4: '• Use Firebase and JWT Authentication.',
            technologies: [
                { id: 1, tech: 'reactJs' },
                { id: 2, tech: 'tailwindCSS' },
                { id: 3, tech: 'daisyUi' },
                { id: 4, tech: 'javascript' },
                { id: 5, tech: 'nodeJs' },
                { id: 6, tech: 'mongoDB' },
                { id: 7, tech: 'firebase' },
                { id: 8, tech: 'JWT' },
                { id: 9, tech: 'stripePayment' },
            ],
        },
        {
            id: 2,
            title: 'Medico',
            src: img9,
            href: 'https://medico-eb8e9.web.app/',
            detail:
                'It`s an e-commerce web app for buying medicine — like an online pharmacy store.',
            github: 'https://github.com/sabidalam/Medico-Client',
            feature_1: '• Search Medicine by uploading a prescription.',
            feature_2: '• Quick Search and Easy Cart System.',
            feature_3: '• Use SSL-Commerze for payment system.',
            feature_4: '• Separate Dashboard for admin and user.',
            technologies: [
                { id: 1, tech: 'reactJs' },
                { id: 2, tech: 'react-redux' },
                { id: 3, tech: 'daisyUi' },
                { id: 4, tech: 'javascript' },
                { id: 5, tech: 'nodeJs' },
                { id: 6, tech: 'mongoDB' },
                { id: 7, tech: 'firebase' },
                { id: 8, tech: 'JWT' },
                { id: 9, tech: 'SSL-Commerze' },
            ],
        },
        {
            id: 3,
            title: 'Pro-Capture',
            src: img2,
            href: 'https://pro-capture.web.app/',
            detail: 'It is a nature and wildlife photographer website. The photographer can give you some photography services.',
            github: 'https://github.com/sabidalam/Pro-Capture',
            feature_1: '• Users can view all the services, take services',
            feature_2: '• Users can view all reviews also add, delete and update their own reviews',
            feature_3: '• Users can add new services for them.',
            feature_4: '• Use Firebase and JWT Authentication.',
            technologies: [
                {
                    id: 1,
                    tech: 'reactJs',
                },
                {
                    id: 2,
                    tech: 'tailwindCSS',
                },
                {
                    id: 3,
                    tech: 'daisyUi',
                },
                {
                    id: 4,
                    tech: 'nodeJs',
                },
                {
                    id: 5,
                    tech: 'mongoDB',
                },
                {
                    id: 6,
                    tech: 'firebase',
                },
                {
                    id: 7,
                    tech: 'JWT',
                },
            ]

        },
        {
            id: 4,
            title: 'Computer Science Academy',
            src: img3,
            href: 'https://computer-science-academy-a2283.web.app/',
            detail: 'It is an e-learning platform for computer science learning. There are many exclusive courses about computer science for users.',
            github: 'https://github.com/sabidalam/Computer-Science-Academy',
            feature_1: '• Users can see all courses and take premium access.',
            feature_2: '• Users can download a course in pdf format.',
            feature_3: '• Toggle Dark and Light mood.',
            feature_4: '• Use Firebase Authentication.',
            technologies: [
                {
                    id: 1,
                    tech: 'reactJs',
                },
                {
                    id: 2,
                    tech: 'bootstrap',
                },
                {
                    id: 3,
                    tech: 'javascript',
                },
                {
                    id: 4,
                    tech: 'firebase',
                }
            ]

        },
        {
            id: 5,
            title: 'Car Doctor',
            src: img4,
            href: 'https://genius-car-ab208.web.app/',
            detail: 'A car service website, where users can order and take services for their car.',
            github: 'https://github.com/sabidalam/Car-Doctor-Client',
            feature_1: '• User can order multiple car services',
            feature_2: '• Users can delete and update their orders.',
            feature_3: '• Admin can approved or delete user orders.',
            feature_4: '• Used Pagination.',
            technologies: [
                {
                    id: 1,
                    tech: 'reactJs',
                },
                {
                    id: 2,
                    tech: 'tailwindCSS',
                },
                {
                    id: 3,
                    tech: 'daisyUi',
                },
                {
                    id: 4,
                    tech: 'nodeJs',
                },
                {
                    id: 5,
                    tech: 'mongoDB',
                },
                {
                    id: 6,
                    tech: 'firebase',
                },
                {
                    id: 7,
                    tech: 'JWT',
                },
            ]
        },
        {
            id: 6,
            title: 'Doctor`s Portal',
            src: img6,
            href: 'https://doctors-portal-24e72.web.app/',
            detail: 'It`s a dentist appointment taking website, where user can book multiple appointment for dental service.',
            github: 'https://github.com/sabidalam/Doctors-Portal-Client',
            feature_1: '• Separate dashboard for admin and user.',
            feature_2: '• Admin can view and manage(add, delete) all doctors and users.',
            feature_3: '• User can book doctors appointment.',
            feature_4: '• Used Stripe payment method.',
            technologies: [
                {
                    id: 1,
                    tech: 'reactJs',
                },
                {
                    id: 2,
                    tech: 'tailwindCSS',
                },
                {
                    id: 3,
                    tech: 'daisyUi',
                },
                {
                    id: 4,
                    tech: 'nodeJs',
                },
                {
                    id: 5,
                    tech: 'mongoDB',
                },
                {
                    id: 6,
                    tech: 'firebase',
                },
                {
                    id: 7,
                    tech: 'JWT',
                },
                {
                    id: 8,
                    tech: 'reactQuery',
                },
                {
                    id: 9,
                    tech: 'stripePayment',
                },
            ]
        },
        {
            id: 7,
            title: 'Hot News',
            src: img5,
            href: 'https://hot-news-dd5ad.web.app/',
            detail: 'A news portal website, where user can visit category-wise news and get update about international news.',
            github: 'https://github.com/sabidalam/Hot-News-Client',
            feature_1: '• Users can visit category-wise news',
            feature_2: '• News is mostly sorted by views',
            feature_3: '• Use context Api',
            feature_4: '• Use Firebase Authentication.',
            technologies: [
                {
                    id: 1,
                    tech: 'reactJs',
                },
                {
                    id: 2,
                    tech: 'reactBootstrap',
                },
                {
                    id: 3,
                    tech: 'javascript',
                },
                {
                    id: 4,
                    tech: 'nodeJs',
                },
                {
                    id: 5,
                    tech: 'mongoDB',
                },
                {
                    id: 6,
                    tech: 'firebase',
                },
            ]
        },
        {
            id: 8,
            title: 'Crazy Test',
            src: img8,
            href: 'https://genius-car-ab208.web.app/',
            detail: 'It`s a crazy and easy quiz-test website. Quizzes are about Programming languages like react, javascript and many more.',
            github: 'https://github.com/sabidalam/Car-Doctor-Client',
            feature_1: '• Displayed all quiz questions dynamically and showed answers with the button.',
            feature_2: '• It is a single-page website with Dynamic Routing',
            feature_3: '• Use API Data',
            feature_4: '• Responsive website.',
            technologies: [
                {
                    id: 1,
                    tech: 'reactJs',
                },
                {
                    id: 2,
                    tech: 'tailwindCSS',
                },
                {
                    id: 3,
                    tech: 'recharts',
                },
                {
                    id: 4,
                    tech: 'Netlify',
                },
            ]
        },
        {
            id: 9,
            title: 'Ema John',
            src: img7,
            href: 'https://ema-john-e-commarce.netlify.app/',
            detail: 'An online e-commerce website.',
            github: 'https://github.com/sabidalam/ema-john',
            feature_1: '• User can buy many products.',
            feature_2: '• User can review and delete their orders.',
            feature_3: '',
            feature_4: '',
            technologies: [
                {
                    id: 1,
                    tech: 'reactJs',
                },
                {
                    id: 2,
                    tech: 'CSS3',
                },
                {
                    id: 3,
                    tech: 'bootstrap5',
                },
                {
                    id: 4,
                    tech: 'javascript',
                },
                {
                    id: 4,
                    tech: 'Netlify',
                },

            ]
        }
        // ... add other development projects here
    ];

    //  UI Design Projects
    const uiProjects = [
        {
            id: 1,
            title: 'PackMate (Smart Packing App for Travelers)',
            src: img12,
            href: 'https://www.behance.net/gallery/245596371/PackMate-%28Smart-Packing-App-for-Travelers%29',
            detail: 'Travelers often forget important items when packing for trips. PackMate solves this problem by generating a personalized packing checklist based on trip details, that helps users pack efficiently and travel stress-free.',
            technologies: [
                { id: 1, tech: 'Figma' },
                { id: 2, tech: 'Miro' },
                { id: 3, tech: 'Canva' },
                { id: 4, tech: 'User Flow' },
                { id: 5, tech: 'Wireframe' },
                { id: 6, tech: 'Prototyping' },
            ],
        },
        {
            id: 2,
            title: 'Foodster (UI Design)',
            src: img10,
            href: '',
            detail:
                'Re-design of a Food Ordering App.',
            technologies: [
                { id: 1, tech: 'Figma' },
                { id: 2, tech: 'UI Design' },
                { id: 3, tech: 'Prototyping' },
                { id: 4, tech: 'User Flow' },
            ],
        },
        {
            id: 3,
            title: 'Admin Dashboard for an E-commerce App',
            src: img11,
            href: '#',
            detail:
                '',
            technologies: [
                { id: 1, tech: 'Figma' },
                { id: 2, tech: 'Prototyping' },
                { id: 3, tech: 'Wireframing' },
            ],
        },
    ];

    // 🔹 Choose which projects to show
    const displayedProjects = category === 'ui' ? uiProjects : devProjects;

    return (
        <div name="works" className="bg-[#070716]">
            <div className="p-4 text-white">
                <div className="text-center">
                    <p className="lines">
                        <span className="ml-12 text-sm">take a look at my</span>
                    </p>
                    <p className="text-3xl font-bold inline">Projects</p>

                    {/* 🔹 Animated Toggle Switch */}
                    <div className="mt-6 flex justify-center">
                        <div
                            className="relative w-64 h-10 bg-gray-800 rounded-full flex items-center p-1 cursor-pointer select-none"
                            onClick={() =>
                                setCategory(category === 'ui' ? 'development' : 'ui')
                            }
                        >
                            <div
                                className={`absolute top-[3px] left-[3px] w-[calc(50%-3px)] h-[calc(100%-6px)]  bg-gradient-to-r from-cyan-500 to-blue-500 rounded-full transition-all duration-500 ease-in-out ${category === 'development' ? 'translate-x-full' : 'translate-x-0'
                                    }`}
                            ></div>

                            <div className="relative z-10 flex justify-between w-full px-5 text-sm font-medium">
                                <span
                                    className={`transition-colors duration-300 ${category === 'ui' ? 'text-white' : 'text-gray-400'
                                        }`}
                                >
                                    UI Design
                                </span>
                                <span
                                    className={`transition-colors duration-300 ${category === 'development' ? 'text-white' : 'text-gray-400'
                                        }`}
                                >
                                    Development
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* 🔹 Project Grid */}
                <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-8 max-w-sm md:max-w-2xl lg:max-w-5xl mx-auto mt-16">
                    {displayedProjects
                        .slice(0, visible)
                        .map(
                            ({
                                id,
                                title,
                                src,
                                href,
                                detail,
                                github,
                                feature_1,
                                feature_2,
                                feature_3,
                                feature_4,
                                technologies,
                            }) => (
                                <div
                                    key={id}
                                    className="group relative cursor-pointer items-center justify-center overflow-hidden transition-shadow shadow-md shadow-gray-400 hover:shadow-xl h-96 rounded-xl"
                                >
                                    <div className="card h-80 rounded-xl">
                                        {category === 'ui' ? (<figure>
                                            <img
                                                src={src}
                                                className="w-full h-72 object-cover"
                                                alt={title}
                                            />
                                        </figure>) : (<figure>
                                            <img
                                                src={src}
                                                className="w-full h-48 lg:h-60 object-cover"
                                                alt={title}
                                            />
                                        </figure>)}

                                        <div className="text-white text-lg font-semibold py-2 px-4">
                                            {category === 'ui' ? (<h2 className="text-center text-xl py-2">{title}</h2>) : (
                                                <div>
                                                    <h2 className="text-center text-xl">{title}</h2>
                                                    <span className="text-left mr-4">Technologies:</span>
                                                    {technologies.map(({ id, tech }) => (
                                                        <p
                                                            key={id}
                                                            className="border-2 rounded-lg inline-block border-gray-700 p-2 mt-2 mr-2 text-xs"
                                                        >
                                                            {tech}
                                                        </p>
                                                    ))}
                                                </div>
                                            )}

                                        </div>
                                    </div>

                                    <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent group-hover:bg-gray-700/95"></div>
                                    <div className="absolute inset-0 flex translate-y-[100%] flex-col items-center justify-center px-3 lg:px-9 transition-all duration-500 group-hover:translate-y-2">
                                        <div className="max-w-xs lg:max-w-lg mx-auto text-left">
                                            {category === 'ui' ?
                                                (<div>
                                                    <h2 className="text-lg text-white py-2">{detail}</h2>
                                                    <span className="text-left mr-4">Technologies:</span>
                                                    {technologies.map(({ id, tech }) => (
                                                        <p
                                                            key={id}
                                                            className="border-2 rounded-lg inline-block border-gray-100 p-2 mt-2 mr-2 text-xs"
                                                        >
                                                            {tech}
                                                        </p>
                                                    ))}
                                                </div>


                                                ) : (
                                                    <div>
                                                        <h2 className="text-lg text-white mb-3">{detail}</h2>
                                                        <p className="text-lg">Features:</p>
                                                        <ul>
                                                            <li>{feature_1}</li>
                                                            <li>{feature_2}</li>
                                                            <li>{feature_3}</li>
                                                            <li>{feature_4}</li>
                                                        </ul>
                                                    </div>
                                                )}
                                            {category === 'ui' ? (
                                                <div className="flex justify-center">
                                                    <button className="px-6 py-3 mt-2 duration-200 hover:scale-105">
                                                        <a href={href} target="_blank" rel="noreferrer">
                                                            <span className="flex items-center justify-between bg-gray-900 rounded py-2 px-4">
                                                                Project Link <FaExternalLinkAlt className="ml-2" />
                                                            </span>
                                                        </a>
                                                    </button>
                                                </div>
                                            ) : (
                                                <div className="flex items-center justify-between">
                                                    <button className="w-1/2 px-6 py-3 lg:mx-6 mt-3 duration-200 hover:scale-105">
                                                        <a href={href} target="_blank" rel="noreferrer">
                                                            <span className="flex items-center justify-between bg-gray-900 rounded py-2 px-3">
                                                                Live Site <FaExternalLinkAlt className="ml-2" />
                                                            </span>
                                                        </a>
                                                    </button>
                                                    <button className="w-1/2 px-7 py-3 lg:mx-6 mt-3 duration-200 hover:scale-105">
                                                        <a href={github} target="_blank" rel="noreferrer">
                                                            <span className="flex items-center justify-between bg-gray-900 rounded py-2 px-4">
                                                                GitHub <FaGithub className="ml-1" />
                                                            </span>
                                                        </a>
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )
                        )}
                </div>

                {/* 🔹 Show More / Less */}
                <div className="flex justify-center mt-10">
                    {visible >= displayedProjects.length ? (
                        <button
                            onClick={hideButton}
                            className="text-white px-4 py-3 my-2 flex items-center rounded-md hover:scale-105 bg-gradient-to-r from-cyan-500 to-blue-500 cursor-pointer"
                        >
                            Show less
                        </button>
                    ) : (
                        <button
                            onClick={showButton}
                            className="text-white px-4 py-3 my-2 flex items-center rounded-md hover:scale-105 bg-gradient-to-r from-cyan-500 to-blue-500 cursor-pointer"
                        >
                            Show More
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Projects;

